import { RegisterAsGroupIcon } from "@/assets";
import NewUsersIcon24 from "@/assets/SVG/newUsersIcon24";
import { Modal } from "@/components";
import Badge from "@/components/badge/Badge";
import Card from "@/pages/admin/dashboard/components/Card";
import { Grid, IconButton, Typography, useMediaQuery } from "@mui/material";
import TripsTable from "./TripsTable";
import { useCallback, useEffect, useState } from "react";
import { getTotalReceptedPatients } from "@/api/group";
import ClockIcon from "@/assets/SVG/clockIcon";

function PersonalInfo({ level, totalReceptedPatients, tripTables }) {
  const md = useMediaQuery("(max-width:450px)");
  const [loading, setLoading] = useState(false);
  const [totalRecepted, setTotalRecepted] = useState();

  const fetchTotalRecepted = useCallback(() => {
    setLoading(true);
    getTotalReceptedPatients("forceReload=true")
      .then((res) => setTotalRecepted(res))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    setTotalRecepted(totalReceptedPatients);
  }, [totalReceptedPatients]);

  return (
    <>
      <Grid
        display={"flex"}
        flexDirection={"row"}
        gap={"10px"}
        alignItems={"center"}
      >
        <Typography>{`تاریخ آخرین به روزرسانی ${totalRecepted?.refreshAt ?? "-"}`}</Typography>
        {!loading && (
          <IconButton onClick={() => fetchTotalRecepted()}>
            <ClockIcon />
          </IconButton>
        )}
      </Grid>
      <Grid display={"flex"} flexDirection={md ? "column" : "row"} gap={"10px"}>
        <Grid
          display={"flex"}
          flexDirection={"column"}
          height={"stretch"}
          gap={"10px"}
          justifyContent={"space-between"}
        >
          <Badge level={level} />
          <Card
            title={"کل مراجعین پذیرش شده شما"}
            icon={<NewUsersIcon24 />}
            counter={totalRecepted?.data ?? "-"}
            width="400px"
            unit={"نفر"}
          />
        </Grid>
        <Modal
          titleVariant="body2"
          title={"اردوهای شما"}
          icon={<RegisterAsGroupIcon />}
          width={md ? "100%" : "calc(100% - 420px)"}
        >
          {tripTables?.trips && <TripsTable trips={tripTables.trips} />}
        </Modal>
      </Grid>
    </>
  );
}

export default PersonalInfo;
